var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"n2-valid",class:{'n2-errors':_vm.errors}},_vm._l((_vm.errors),function(error){return _c('li',{key:error},[_vm._v(_vm._s(error))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }